"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var meta_category_1 = require("./meta-category");
var MetaCategoryOffline = /** @class */ (function (_super) {
    __extends(MetaCategoryOffline, _super);
    function MetaCategoryOffline(metaCategoryId, displayNameMsgId, hasCustomSorting, identityMetaFieldId, instanceMetaFieldId, isSearchable, searchableMetaFieldIds, hasIcon, defaultIconPath, wfProcessId, isCacheable, isWithVersioning, isClassifier, nameMetaFieldIds, keyMetaFieldIds, actionDataMetaFieldIds) {
        var _this = _super.call(this, metaCategoryId, displayNameMsgId, hasCustomSorting, hasIcon, defaultIconPath, wfProcessId, isCacheable, nameMetaFieldIds, isWithVersioning, isClassifier, keyMetaFieldIds, actionDataMetaFieldIds) || this;
        _this.identityMetaFieldId = identityMetaFieldId;
        _this.instanceMetaFieldId = instanceMetaFieldId;
        _this.isSearchable = isSearchable;
        _this.searchableMetaFieldIds = searchableMetaFieldIds;
        return _this;
    }
    MetaCategoryOffline.prototype.getIdentityMetaFieldId = function () {
        return this.identityMetaFieldId;
    };
    MetaCategoryOffline.prototype.getInstanceMetaFieldId = function () {
        return this.instanceMetaFieldId;
    };
    MetaCategoryOffline.prototype.getIsSearchable = function () {
        return this.isSearchable;
    };
    MetaCategoryOffline.prototype.getSearchableMetaFieldIds = function () {
        return this.searchableMetaFieldIds;
    };
    return MetaCategoryOffline;
}(meta_category_1.MetaCategory));
exports.MetaCategoryOffline = MetaCategoryOffline;
//# sourceMappingURL=meta-category-offline.js.map